<div class="h-10 bg-bnpp-green w-full"></div>
<div class="flex items-center justify-center bg-white shadow ">
  <div class="flex justify-between p-4 w-[80vw]">
    <div class="flex items-center space-x-2">
      <img src="{{logoUrl()}}" alt="BNP Logo" class="h-10">
      <div class="flex flex-col  sm:flex-row sm:items-baseline sm:space-x-2">
        <span class="text-sm font-bold text-gray-500">| Indx</span>
        <span class="text-sm font-bold text-gray-800 ml-8">The bank for a changing world</span>
      </div>
    </div>
    <div class="flex items-center space-x-2">
      <div class="relative">
        <input type="text" [(ngModel)]="searchTerm" (keydown.enter)="onSearch()" placeholder="Search Index" class="w-80 pl-4 pr-10 py-2 border border-gray-300 rounded
      focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
        <button (click)="onSearch()" class="absolute right-0 top-1/2 transform -translate-y-1/2 bg-bnpp-green text-white  w-10 h-10
      flex items-center justify-center">
          <i class="pi pi-search"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<div>
</div>